export const fontFamilyRegular =
  'font-family: "Poppins", sans-serif; font-weight: 400;';
export const fontFamilyBolder =
  'font-family: "Poppins", sans-serif; font-weight: 600;';
export const fontFamilyBold =
  'font-family: "Poppins", sans-serif; font-weight: 500;';
